import ModalDelete from "./DeleteModal";

export default ModalDelete;
